import React, { useEffect } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

function Index({
	selectedItem,
	setSelectedItem,
	createUpdate,
	modalCreateUpdate,
	toggleModalCreateUpdate
}) {
	const { t } = useTranslation()

	useEffect(() => {
		//
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* MODAL CREATE UPDATE*/}
			<Modal Modal show={modalCreateUpdate} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalCreateUpdate()
				}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<span>{t('create')}</span>
							:
							<span>{t('edit')}</span>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="d-flex gap-2">
							<div className="form-group w-100">
								<label>{t('name')}</label>
								<input type="text" className="form-control" name="first_name" value={selectedItem.first_name ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'first_name': e.target.value })} />
							</div>
							<div className="form-group w-100">
								<label>{t('phone')}</label>
								<input type="number" className="form-control" name="phone" value={selectedItem.phone ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'phone': e.target.value })} />
							</div>
						</div>

						<div className="d-flex gap-2">
							<div className="form-group w-100">
								<label>{t('login')}</label>
								<input type="text" className="form-control"
									disabled={selectedItem.id}
									name="login" value={selectedItem.login ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'login': e.target.value.toLowerCase() })} />
							</div>
							<div className="form-group w-100">
								<label>{t('password')}</label>
								<input type="text" className="form-control"
									name="password" value={selectedItem.password ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'password': e.target.value })} />
							</div>
						</div>

						<div className="form-group w-100">
							<label>TELEGRAM ID</label>
							<input type="text" className="form-control" name="telegram_user_id" value={selectedItem.telegram_user_id ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'telegram_user_id': e.target.value })} />
						</div>


						<div className="form-group w-100">
							<label>Номер карты</label>
							<input type="text" className="form-control" name="card_number" value={selectedItem.card_number ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'card_number': e.target.value })} />
						</div>

						<hr />

						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalCreateUpdate()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE UPDATE*/}
		</>
	)
}

export default Index